<template>
  <div>
    <Banner />
    <Layout />
    <ow-footer />
  </div>
</template>
<script>
import Banner from "./components/banner";
import Layout from "./components/layout";
import OwFooter from "@/components/ow-footer";
export default {
  name: "solution",
  components: {
    Banner,
    Layout,
    OwFooter
  }
};
</script>
